import React, { FC } from "react"
import classes from "./Footer.module.scss"
import { AuthConsumer } from "../../context/auth/authContext"

const Footer: FC = () => {
  return (
    <AuthConsumer>
      {context =>
        context.authenticated && (
          <div className={classes.footerRoot}>
            <div className={classes.footerContent}>
              <p>
                Copyright © {new Date().getFullYear()}{" "}
                <a
                  href="hallenconstruction.net"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Hallen Construction.
                </a>{" "}
                All Rights Reserved.
              </p>
            </div>
          </div>
        )
      }
    </AuthConsumer>
  )
}

export default Footer
